import React from 'react'
import { SelectDropdown, type DropDownItemOptionComponentProps, type SelectOption } from '../../../SelectDropdown/SelectDropdown'
import type { ZocksReferenceWidgetProps } from './registry'

interface ReferencePickerProps extends ZocksReferenceWidgetProps {
  options: SelectOption[]
  loading: boolean
  dropDownItemOptionComponent?: React.ComponentType<DropDownItemOptionComponentProps>
}

export const ReferencePicker: React.FC<ReferencePickerProps> = ({
  options,
  loading,
  value,
  onChange,
  disabled,
  required,
  label,
  id,
  dropDownItemOptionComponent,
}) => {
  const matchedOption = options.find((option) => option.id === value)
  const unresolvedOption: SelectOption | null = !matchedOption && value ? { id: value, label: `${value} (not found)` } : null
  const dropdownOptions = unresolvedOption ? [unresolvedOption, ...options] : options

  return (
    <SelectDropdown
      key={value}
      options={dropdownOptions}
      initialSelectedOption={matchedOption ?? unresolvedOption}
      searchable
      loading={loading}
      disabled={disabled}
      placeholder='Select…'
      showDeselectOption={!required}
      onDeselect={() => onChange(undefined)}
      onOptionSelected={(option) => onChange(option.id)}
      ariaLabel={label}
      toggleId={id}
      DropDownItemOptionComponent={dropDownItemOptionComponent}
    />
  )
}
